import { PairLiquidityFormatted } from '@root/entities/pair/ui/common/pair-liquidity-formatted'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'

import { TextCell } from './explore-text-cell'

import type { PairModel } from '@root/entities/pair'

export const LiquidityCell = ({ pair }: { pair: PairModel }) => {
  return (
    <TextCell>
      <FlashTextContentDistinct>
        <PairLiquidityFormatted pair={pair} />
      </FlashTextContentDistinct>
    </TextCell>
  )
}
